'use client'

import { useEffect, useState } from 'react'
import { useRefinementList, UseRefinementListProps } from 'react-instantsearch'

import DraggableArea from '@/components/ui/DraggableArea'

function SearchResultsFilters(props: UseRefinementListProps) {
  const { items, refine } = useRefinementList(props)
  const [selectedTab, setSelectedTab] = useState<string | null>(null)

  useEffect(() => {
    setSelectedTab(null)
  }, [props.attribute])

  const handleTabClick = (value: string) => {
    if (selectedTab === value) {
      // Clicking the same tab again - clear the refinement
      refine(value) // Toggle off in InstantSearch
      setSelectedTab(null)
    } else {
      // Before applying a new refinement, clear the previous one if any
      if (selectedTab) {
        refine(selectedTab) // Toggle off the previously selected value
      }

      // Apply the new refinement
      refine(value) // Toggle on the new value
      setSelectedTab(value)
    }
  }

  const handleAllClick = () => {
    // If there's a selected tab, clear it
    if (selectedTab) {
      refine(selectedTab) // Toggle off the currently selected value
    }
    setSelectedTab(null)
  }

  if (!items?.length) {
    return null
  }

  // The "All" is active when no tab is selected
  const isAllActive = selectedTab === null

  return (
    <nav className="relative h-[60px] overflow-hidden border-y border-gradient">
      <div
        aria-hidden={true}
        className="absolute left-0 top-0 h-full w-[80px] bg-gradient-to-l from-transparent from-30% to-white l-up:hidden"></div>

      <DraggableArea className="container container--l flex h-[120px] flex-nowrap gap-x-l overflow-x-auto">
        <ul className="flex flex-nowrap gap-x-l">
          {/* All tab */}
          <li key="all" className="snap-start">
            <button
              onClick={handleAllClick}
              className={`flex items-center gap-x-xxxs px-s text-17 ${
                isAllActive ? 'border-b-2 border-black py-15' : 'py-16'
              }`}>
              <span className="whitespace-nowrap">All</span>
            </button>
          </li>

          {/* Filter tabs */}
          {items.map(({ label, value, count }) => (
            <li key={value} className="snap-start">
              <button
                onClick={() => handleTabClick(value)}
                className={`flex items-center gap-x-xxxs px-s text-17 ${
                  selectedTab === value ? 'border-b-2 border-black py-15' : 'py-16'
                }`}>
                <span className="whitespace-nowrap">
                  {label} ({count})
                </span>
              </button>
            </li>
          ))}
        </ul>
      </DraggableArea>

      <div
        aria-hidden={true}
        className="absolute right-0 top-0 h-full w-[80px] bg-gradient-to-r from-transparent from-30% to-white l-up:hidden"></div>
    </nav>
  )
}

export default SearchResultsFilters
